export default __webpack_public_path__ + "7d393d382f3e7fb1c637280a90a3434b.woff2";